export default {
  search: (data) => $nuxt.$axios.get($nuxt.$api.host + '/search', data),
}
